import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Modal from "react-modal";
import ModalHeader from "react-bootstrap/esm/ModalHeader";
import { ModalBody } from "react-bootstrap";
import { clearErrors } from "../../store/actions/errorActions";
import "./AuthModal.css";
import Login from "./Login";
import OTPLogin from "./OTPLogin";
import Signup from "./Signup";
import SignupOTP from "./SignupOTP";
import { clearPopups } from "../../store/actions/popupActions";

Modal.setAppElement("body");

/**
 * BOC
 * API Security - Step 4 OTP login / signup UI
 * date 23-10-2026
 * use_of_code: Login / signup popup with OTP screens only (LOGIN, LOGIN WITH OTP, SIGN UP, SIGN UP WITH OTP).
 * Forgot password and the Apple e-mail screen are not used any more (no password, e-mail comes from the
 * verified Apple token).
 */
const MODAL_HEADERS = {
  login: "LOGIN",
  otplogin: "LOGIN WITH OTP",
  signup: "SIGN UP",
  signupotp: "SIGN UP WITH OTP",
};

const BACK_FORM = {
  otplogin: "login",
  signup: "login",
  signupotp: "signup",
};

function AuthModal() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const authState = useSelector((state) => state.auth);

  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [activeForm, setActiveForm] = useState("login");

  const [sendOtpResponse, setSendOtpResponse] = useState(null);
  const [otpUserName, setOtpUserName] = useState("");
  const [signupOtpResponse, setSignupOtpResponse] = useState(null);
  const [signupData, setSignupData] = useState(null);

  useEffect(() => {
    if (authState?.token && authState?.isAuthenticated && authState?.user) {
      setIsAuthenticated(true);
    } else {
      setIsAuthenticated(false);
    }
  }, [authState]);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const toggle = () => {
    //clear errors
    dispatch(clearErrors());

    if (isModalOpen) {
      dispatch(clearPopups());
    }
    setIsModalOpen(!isModalOpen);
  };

  const popupState = useSelector((state) => state.popup);

  useEffect(() => {
    if (popupState?.popupId === "login") {
      toggleAuthFormCb("login");
      setIsModalOpen(true);
    } else if (popupState?.popupId === "signup") {
      toggleAuthFormCb("signup");
      setIsModalOpen(true);
    } else {
      setIsModalOpen(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [popupState]);

  const customStyles = {
    overlay: { zIndex: "999999", backgroundColor: "rgb(0 0 0 / 75%)" },
  };

  const toggleAuthFormCb = (formName) => {
    if (MODAL_HEADERS[formName]) {
      dispatch(clearErrors());
      setActiveForm(formName);
    }
  };

  const setVerifyOTPResponse = (res, user) => {
    setSendOtpResponse(res);
    setOtpUserName(user);
  };

  const setSignupOTPResponse = (res, data) => {
    setSignupOtpResponse(res);
    setSignupData(data);
  };

  const onSignupSuccess = () => {
    setSignupOTPResponse(null, null);
    setActiveForm("login");
    dispatch(clearPopups());
    navigate("/account-created");
  };

  return (
    <>
      <Modal
        isOpen={isModalOpen && !isAuthenticated}
        toggle={toggle}
        style={customStyles}
        onRequestClose={toggle}
        shouldCloseOnOverlayClick={true}
        id="authModal"
      >
        <ModalHeader
          className={`custom-auth-header custom-header${"-" + activeForm}`}
        >
          {BACK_FORM[activeForm] && (
            <button
              onClick={(e) => toggleAuthFormCb(BACK_FORM[activeForm])}
              className="btn-blank"
            >
              <img
                src={
                  process.env.PUBLIC_URL +
                  "/assets/images/icons/right-arrow-angle.png"
                }
                className="back-btn-newsletter"
                alt=""
              />
            </button>
          )}

          <h3>{MODAL_HEADERS[activeForm]}</h3>
          <button onClick={toggle} className="btn-blank">
            <img
              src={
                process.env.PUBLIC_URL + "/assets/images/icons/Cross-Button.png"
              }
              className="close-btn-newsletter"
              alt=""
            />
          </button>
        </ModalHeader>
        <ModalBody>
          {activeForm === "login" && (
            <Login
              active={true}
              toggleAuthFormCb={toggleAuthFormCb}
              setVerifyOTPResponse={setVerifyOTPResponse}
            />
          )}

          {activeForm === "otplogin" && (
            <OTPLogin
              active={true}
              toggleAuthFormCb={toggleAuthFormCb}
              otpResponse={sendOtpResponse}
              userName={otpUserName}
              setVerifyOTPResponse={setVerifyOTPResponse}
            />
          )}

          {activeForm === "signup" && (
            <Signup
              active={true}
              toggleAuthFormCb={toggleAuthFormCb}
              setSignupOTPResponse={setSignupOTPResponse}
            />
          )}

          {activeForm === "signupotp" && (
            <SignupOTP
              active={true}
              otpResponse={signupOtpResponse}
              signupData={signupData}
              onSignupSuccess={onSignupSuccess}
            />
          )}
        </ModalBody>
      </Modal>
    </>
  );
}
/**
 * EOC
 */
export default AuthModal;
